import script from "./PasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordView.vue?vue&type=style&index=0&id=34435790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34435790"]])

export default __exports__